import {enqueueSnackbar} from "notistack";

export default function successToast(message) {
    return enqueueSnackbar(message, {
        variant: 'success',
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        }
    })
}